import { Outlet } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import WhatsAppButton from './WhatsAppButton'
import DonsModal from '@/components/DonsModal'
import ScrollToTop from '@/components/ScrollToTop'
import { DonsModalProvider } from '@/context/DonsModalContext'

export default function Layout() {
  return (
    <DonsModalProvider>
      <div className="min-h-svh flex flex-col bg-white">
        <ScrollToTop />
        <Header />
        {/* pt-16 réserve la hauteur du header (fixed, h-16) ; HeroSection s'en affranchit avec -mt-16
            pour passer sous le header transparent en haut de la page d'accueil. */}
        <main className="flex-1 pb-20 md:pb-0 pt-16">
          <Outlet />
        </main>
        <Footer />
        <WhatsAppButton />
        {/* <MobileNav /> */}
        <DonsModal />
      </div>
    </DonsModalProvider>
  )
}
